
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerXShape as ObiBeaconTowerXShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-x-shape.js';
 
 
 

 
 export const ObiBeaconTowerXShape = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-x-shape',
   elementClass: ObiBeaconTowerXShapeElement,
   events: {
     
   }
  });
 
 